// AUTO-GENERATED by scripts/generate-sku-pairs.mjs
// DO NOT EDIT MANUALLY. Run `npx tsx scripts/generate-sku-pairs.mjs` to regenerate.
//
// Top 200 SKU comparison pairs for programmatic SEO. Each pair is
// rendered as /compare/sku/{slug} → SkuComparisonPage component.
//
// Strategy:
//   - within-brand: top models in same (manufacturer, type, megapixel) bucket
//   - cross-brand: top model from each brand in same (type, megapixel) bucket

export interface SkuPair {
  slug: string;
  a: string;
  b: string;
  kind: 'within-brand' | 'cross-brand';
}

export const SKU_COMPARISON_PAIRS: SkuPair[] = [
  {
    "slug": "dahua-tpc-bf3221p-t-vs-dahua-tpc-bf2241-tb10f8",
    "a": "dahua-tpc-bf3221p-t",
    "b": "dahua-tpc-bf2241-tb10f8",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-bf2241-tb10f8-vs-dahua-tpc-bf1241p-t-s2",
    "a": "dahua-tpc-bf2241-tb10f8",
    "b": "dahua-tpc-bf1241p-t-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-bf1241p-t-s2-vs-dahua-tpc-bf2241p-t",
    "a": "dahua-tpc-bf1241p-t-s2",
    "b": "dahua-tpc-bf2241p-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-bf2241p-t-vs-dahua-tpc-bf5421-t",
    "a": "dahua-tpc-bf2241p-t",
    "b": "dahua-tpc-bf5421-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-dahua-ipc-hfw7442h-z4fr",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "dahua-ipc-hfw7442h-z4fr",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7442h-z4fr-vs-dahua-ipc-hfw7442h-z4-s2",
    "a": "dahua-ipc-hfw7442h-z4fr",
    "b": "dahua-ipc-hfw7442h-z4-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7442h-z4-s2-vs-dahua-ipc-hfw5459z-z4he-pv-pro",
    "a": "dahua-ipc-hfw7442h-z4-s2",
    "b": "dahua-ipc-hfw5459z-z4he-pv-pro",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw5459z-z4he-pv-pro-vs-dahua-ipc-hfw7442h-z4-x",
    "a": "dahua-ipc-hfw5459z-z4he-pv-pro",
    "b": "dahua-ipc-hfw7442h-z4-x",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7859z1-z7-pv-x-atc-vs-dahua-ipc-hfw7842h-z4",
    "a": "dahua-ipc-hfw7859z1-z7-pv-x-atc",
    "b": "dahua-ipc-hfw7842h-z4",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7842h-z4-vs-dahua-ipc-hfw7842h-z4-s2",
    "a": "dahua-ipc-hfw7842h-z4",
    "b": "dahua-ipc-hfw7842h-z4-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7842h-z4-s2-vs-dahua-ipc-hfw5859z-z4he-pv-pro",
    "a": "dahua-ipc-hfw7842h-z4-s2",
    "b": "dahua-ipc-hfw5859z-z4he-pv-pro",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw5859z-z4he-pv-pro-vs-dahua-ipc-hfw7859z1-z4-pv-x-atc",
    "a": "dahua-ipc-hfw5859z-z4he-pv-pro",
    "b": "dahua-ipc-hfw7859z1-z4-pv-x-atc",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-df1241-t-vs-dahua-tpc-df1241-tb7f4",
    "a": "dahua-tpc-df1241-t",
    "b": "dahua-tpc-df1241-tb7f4",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-df1241-tb7f4-vs-dahua-tpc-df2241-t",
    "a": "dahua-tpc-df1241-tb7f4",
    "b": "dahua-tpc-df2241-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-df2241-t-vs-dahua-tpc-df2241-tb7",
    "a": "dahua-tpc-df2241-t",
    "b": "dahua-tpc-df2241-tb7",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-df2241-tb7-vs-dahua-tpc-df2241p-tb7",
    "a": "dahua-tpc-df2241-tb7",
    "b": "dahua-tpc-df2241p-tb7",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw3449e-as-il-0600-vs-dahua-ipc-hdbw7442h-zfr",
    "a": "dahua-ipc-hdbw3449e-as-il-0600",
    "b": "dahua-ipc-hdbw7442h-zfr",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw7442h-zfr-vs-dahua-ipc-hdbw5442e-z4e-s3",
    "a": "dahua-ipc-hdbw7442h-zfr",
    "b": "dahua-ipc-hdbw5442e-z4e-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw5442e-z4e-s3-vs-dahua-ipc-hdbw5442e-se-0600b-s3",
    "a": "dahua-ipc-hdbw5442e-z4e-s3",
    "b": "dahua-ipc-hdbw5442e-se-0600b-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw5442e-se-0600b-s3-vs-dahua-ipc-hdbw7442e1-z4-x",
    "a": "dahua-ipc-hdbw5442e-se-0600b-s3",
    "b": "dahua-ipc-hdbw7442e1-z4-x",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdw3849h-as-pv-pro-0360-vs-dahua-ipc-hdbw3849e-as-il-0360",
    "a": "dahua-ipc-hdw3849h-as-pv-pro-0360",
    "b": "dahua-ipc-hdbw3849e-as-il-0360",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw3849e-as-il-0360-vs-dahua-ipc-hdw3849t-zs-il",
    "a": "dahua-ipc-hdbw3849e-as-il-0360",
    "b": "dahua-ipc-hdw3849t-zs-il",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdw3849t-zs-il-vs-dahua-ipc-hdw3849h-as-pv-pro",
    "a": "dahua-ipc-hdw3849t-zs-il",
    "b": "dahua-ipc-hdw3849h-as-pv-pro",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdw3849h-as-pv-pro-vs-dahua-ipc-hdbw5842h-zhe-s3",
    "a": "dahua-ipc-hdw3849h-as-pv-pro",
    "b": "dahua-ipc-hdbw5842h-zhe-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-pt8621a-tb-vs-dahua-tpc-sd8621-t",
    "a": "dahua-tpc-pt8621a-tb",
    "b": "dahua-tpc-sd8621-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-sd8621-t-vs-dahua-tpc-sd8621a-t",
    "a": "dahua-tpc-sd8621-t",
    "b": "dahua-tpc-sd8621a-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-sd8621a-t-vs-dahua-tpc-pt8420a-t",
    "a": "dahua-tpc-sd8621a-t",
    "b": "dahua-tpc-pt8420a-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-pt8420a-t-vs-dahua-tpc-pt8420a-ta",
    "a": "dahua-tpc-pt8420a-t",
    "b": "dahua-tpc-pt8420a-ta",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sdt6c432-4p-gb-apv-0280-vs-dahua-sdt6c425-4p-gb-apv-0280",
    "a": "dahua-sdt6c432-4p-gb-apv-0280",
    "b": "dahua-sdt6c425-4p-gb-apv-0280",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sdt6c425-4p-gb-apv-0280-vs-dahua-sd8a440-hnf-pa",
    "a": "dahua-sdt6c425-4p-gb-apv-0280",
    "b": "dahua-sd8a440-hnf-pa",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd8a440-hnf-pa-vs-dahua-sd8a440fa-hnt",
    "a": "dahua-sd8a440-hnf-pa",
    "b": "dahua-sd8a440fa-hnt",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd8a440fa-hnt-vs-dahua-sd8a440ga-hnv",
    "a": "dahua-sd8a440fa-hnt",
    "b": "dahua-sd8a440ga-hnv",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd8a840-hnf-pa-vs-dahua-sdt3e410-8p-mb-a-pv1",
    "a": "dahua-sd8a840-hnf-pa",
    "b": "dahua-sdt3e410-8p-mb-a-pv1",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sdt3e410-8p-mb-a-pv1-vs-dahua-sd6al845xa-hnr-ir",
    "a": "dahua-sdt3e410-8p-mb-a-pv1",
    "b": "dahua-sd6al845xa-hnr-ir",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd6al845xa-hnr-ir-vs-dahua-sd8a840wa-hnf",
    "a": "dahua-sd6al845xa-hnr-ir",
    "b": "dahua-sd8a840wa-hnf",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd8a840wa-hnf-vs-dahua-sd8a840vi-hni",
    "a": "dahua-sd8a840wa-hnf",
    "b": "dahua-sd8a840vi-hni",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-mfw7449y-z7-t8a-vs-dahua-ipc-pfw3849s-a180-as-pv",
    "a": "dahua-ipc-mfw7449y-z7-t8a",
    "b": "dahua-ipc-pfw3849s-a180-as-pv",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-pfw3849s-a180-as-pv-vs-dahua-ipc-pfw8840-a180-s2",
    "a": "dahua-ipc-pfw3849s-a180-as-pv",
    "b": "dahua-ipc-pfw8840-a180-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-pfw8840-a180-s2-vs-dahua-ipc-pfw8840n-a180",
    "a": "dahua-ipc-pfw8840-a180-s2",
    "b": "dahua-ipc-pfw8840n-a180",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-pfw8840n-a180-vs-dahua-ipc-pfw8840-a180",
    "a": "dahua-ipc-pfw8840n-a180",
    "b": "dahua-ipc-pfw8840-a180",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-pdbw82041-b360-s2-vs-dahua-ipc-pdbw82041-b360",
    "a": "dahua-ipc-pdbw82041-b360-s2",
    "b": "dahua-ipc-pdbw82041-b360",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-ew5541-as-vs-dahua-ipc-ew5541-as-s2",
    "a": "dahua-ipc-ew5541-as",
    "b": "dahua-ipc-ew5541-as-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-mfw7449y-z7-t44-vs-dahua-ipc-mfw7442k1-z7-t40",
    "a": "dahua-ipc-mfw7449y-z7-t44",
    "b": "dahua-ipc-mfw7442k1-z7-t40",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-mfw7442k1-z7-t40-vs-dahua-ipc-pfw81642-a180-s2",
    "a": "dahua-ipc-mfw7442k1-z7-t40",
    "b": "dahua-ipc-pfw81642-a180-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-pfw81642-a180-s2-vs-dahua-ipc-pfw81642-a180",
    "a": "dahua-ipc-pfw81642-a180-s2",
    "b": "dahua-ipc-pfw81642-a180",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-pfw81642-a180-vs-dahua-ipc-hdbw5441f-as-e2",
    "a": "dahua-ipc-pfw81642-a180",
    "b": "dahua-ipc-hdbw5441f-as-e2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw71242e-z-x-vs-dahua-ipc-hfw71242e-z-x-s2",
    "a": "dahua-ipc-hfw71242e-z-x",
    "b": "dahua-ipc-hfw71242e-z-x-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw71242e-z-x-s2-vs-dahua-ipc-hfw81230e-z",
    "a": "dahua-ipc-hfw71242e-z-x-s2",
    "b": "dahua-ipc-hfw81230e-z",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw81230e-z-vs-dahua-ipc-hfw81230e-ze",
    "a": "dahua-ipc-hfw81230e-z",
    "b": "dahua-ipc-hfw81230e-ze",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw81230e-ze-vs-dahua-itc952-au3f-irl7zf1640",
    "a": "dahua-ipc-hfw81230e-ze",
    "b": "dahua-itc952-au3f-irl7zf1640",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw71242e-z-x-vs-dahua-ipc-hdbw71242e-z-x-s2",
    "a": "dahua-ipc-hdbw71242e-z-x",
    "b": "dahua-ipc-hdbw71242e-z-x-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-mfw5241t2-e3-ase-v1-vs-dahua-ipc-ew5241-as",
    "a": "dahua-ipc-mfw5241t2-e3-ase-v1",
    "b": "dahua-ipc-ew5241-as",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-ew5241-as-vs-dahua-ipc-pts2249b-e2-s-pv-pro",
    "a": "dahua-ipc-ew5241-as",
    "b": "dahua-ipc-pts2249b-e2-s-pv-pro",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd6ae530u-hni-vs-dahua-sd2a500hb-gn-a-pv-s2",
    "a": "dahua-sd6ae530u-hni",
    "b": "dahua-sd2a500hb-gn-a-pv-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-sd2a500hb-gn-a-pv-s2-vs-dahua-sd2a500hb-gn-aw-pv-s2",
    "a": "dahua-sd2a500hb-gn-a-pv-s2",
    "b": "dahua-sd2a500hb-gn-aw-pv-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-psdw83242m-a360-d845l-s3-vs-dahua-psdw82442m-a270-d440-s3",
    "a": "dahua-psdw83242m-a360-d845l-s3",
    "b": "dahua-psdw82442m-a270-d440-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-psdw82442m-a270-d440-s3-vs-dahua-psdw81642m-a180-d440-s3",
    "a": "dahua-psdw82442m-a270-d440-s3",
    "b": "dahua-psdw81642m-a180-d440-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-psdw81642m-a180-d440-s3-vs-dahua-psdw81652s-a360-d440",
    "a": "dahua-psdw81642m-a180-d440-s3",
    "b": "dahua-psdw81652s-a360-d440",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-psdw81652s-a360-d440-vs-dahua-psdw81642s-a360-d425",
    "a": "dahua-psdw81652s-a360-d440",
    "b": "dahua-psdw81642s-a360-d425",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-hikvision-ds-2td2637-25-qy",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "hikvision-ds-2td2637-25-qy",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2637-25-qy-vs-hikvision-ds-2td2617-10-qa",
    "a": "hikvision-ds-2td2637-25-qy",
    "b": "hikvision-ds-2td2617-10-qa",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2617-10-qa-vs-hikvision-ds-2td2667-15-qy",
    "a": "hikvision-ds-2td2617-10-qa",
    "b": "hikvision-ds-2td2667-15-qy",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-15-qy-vs-hikvision-ds-2td2637-15-qy",
    "a": "hikvision-ds-2td2667-15-qy",
    "b": "hikvision-ds-2td2637-15-qy",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-hikvision-ids-2cd7a45g2-p-izhs-y",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "hikvision-ids-2cd7a45g2-p-izhs-y",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-p-izhs-y-vs-hikvision-ids-2cd7a47g2-p-xzhsy-2-8-12mm",
    "a": "hikvision-ids-2cd7a45g2-p-izhs-y",
    "b": "hikvision-ids-2cd7a47g2-p-xzhsy-2-8-12mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a47g2-p-xzhsy-2-8-12mm-vs-hikvision-ds-2cd4a45g0-iz-h-s",
    "a": "hikvision-ids-2cd7a47g2-p-xzhsy-2-8-12mm",
    "b": "hikvision-ds-2cd4a45g0-iz-h-s",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd4a45g0-iz-h-s-vs-hikvision-ds-2cd3a46g2t-izhs",
    "a": "hikvision-ds-2cd4a45g0-iz-h-s",
    "b": "hikvision-ds-2cd3a46g2t-izhs",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2087g3-li2uy-sl-4mm-vs-hikvision-ids-2cd8v886g0-x2-xzhs-y",
    "a": "hikvision-ds-2cd2087g3-li2uy-sl-4mm",
    "b": "hikvision-ids-2cd8v886g0-x2-xzhs-y",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd8v886g0-x2-xzhs-y-vs-hikvision-ids-2cd8v886g0-x4-xzhs-y",
    "a": "hikvision-ids-2cd8v886g0-x2-xzhs-y",
    "b": "hikvision-ids-2cd8v886g0-x4-xzhs-y",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd8v886g0-x4-xzhs-y-vs-hikvision-ds-2cd3t86g2-4is-y",
    "a": "hikvision-ids-2cd8v886g0-x4-xzhs-y",
    "b": "hikvision-ds-2cd3t86g2-4is-y",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd3t86g2-4is-y-vs-hikvision-ds-2cd3t86g3-2isu-4isu-y",
    "a": "hikvision-ds-2cd3t86g2-4is-y",
    "b": "hikvision-ds-2cd3t86g3-2isu-4isu-y",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-hikvision-ds-2cd1t67g3-liu-sl-2-8mm",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "hikvision-ds-2cd1t67g3-liu-sl-2-8mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-2-8mm-vs-hikvision-ds-2cd2t67g2h-li",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-2-8mm",
    "b": "hikvision-ds-2cd2t67g2h-li",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2t67g2h-li-vs-hikvision-ds-2cd2t67g2h-lisu-sl",
    "a": "hikvision-ds-2cd2t67g2h-li",
    "b": "hikvision-ds-2cd2t67g2h-lisu-sl",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2t67g2h-lisu-sl-vs-hikvision-ds-2cd2t63g2-2li2u",
    "a": "hikvision-ds-2cd2t67g2h-lisu-sl",
    "b": "hikvision-ds-2cd2t63g2-2li2u",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2628t-7-qa-vs-hikvision-ds-2td2628t-7-b-qa",
    "a": "hikvision-ds-2td2628t-7-qa",
    "b": "hikvision-ds-2td2628t-7-b-qa",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2628t-7-b-qa-vs-hikvision-ds-2td2637t-7-qy",
    "a": "hikvision-ds-2td2628t-7-b-qa",
    "b": "hikvision-ds-2td2637t-7-qy",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2637t-7-qy-vs-hikvision-ds-2td1228t-7-qa",
    "a": "hikvision-ds-2td2637t-7-qy",
    "b": "hikvision-ds-2td1228t-7-qa",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td1228t-7-qa-vs-hikvision-ds-2td2628t-3-qa",
    "a": "hikvision-ds-2td1228t-7-qa",
    "b": "hikvision-ds-2td2628t-3-qa",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd1347g3-liu-4mm-vs-hikvision-ds-2cd2343g2-i-8mm",
    "a": "hikvision-ds-2cd1347g3-liu-4mm",
    "b": "hikvision-ds-2cd2343g2-i-8mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2343g2-i-8mm-vs-hikvision-ds-2cd2343g2-iu-8mm",
    "a": "hikvision-ds-2cd2343g2-i-8mm",
    "b": "hikvision-ds-2cd2343g2-iu-8mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2343g2-iu-8mm-vs-hikvision-ds-2cd2543g2-i-8mm",
    "a": "hikvision-ds-2cd2343g2-iu-8mm",
    "b": "hikvision-ds-2cd2543g2-i-8mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2543g2-i-8mm-vs-hikvision-ds-2cd2543g2-iu-8mm",
    "a": "hikvision-ds-2cd2543g2-i-8mm",
    "b": "hikvision-ds-2cd2543g2-iu-8mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd7586g2-p-xzhsy-8-32mm-vs-hikvision-ids-2cd7586g2-p-xzhsy-2-8-12mm",
    "a": "hikvision-ids-2cd7586g2-p-xzhsy-8-32mm",
    "b": "hikvision-ids-2cd7586g2-p-xzhsy-2-8-12mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd7586g2-p-xzhsy-2-8-12mm-vs-hikvision-ids-2cd7587g2-xzhsy-2-8-12mm",
    "a": "hikvision-ids-2cd7586g2-p-xzhsy-2-8-12mm",
    "b": "hikvision-ids-2cd7587g2-xzhsy-2-8-12mm",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ids-2cd7587g2-xzhsy-2-8-12mm-vs-hikvision-ds-2cd2787g3t-lizsy",
    "a": "hikvision-ids-2cd7587g2-xzhsy-2-8-12mm",
    "b": "hikvision-ds-2cd2787g3t-lizsy",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2787g3t-lizsy-vs-hikvision-ds-2cd2h87g3-lizs2uy-sl",
    "a": "hikvision-ds-2cd2787g3t-lizsy",
    "b": "hikvision-ds-2cd2h87g3-lizs2uy-sl",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2766g2h-iptrzs-vs-hikvision-ds-2cd2766g2h-iptrzs2u-s-l-rb",
    "a": "hikvision-ds-2cd2766g2h-iptrzs",
    "b": "hikvision-ds-2cd2766g2h-iptrzs2u-s-l-rb",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2cd2766g2h-iptrzs2u-s-l-rb-vs-hikvision-ds-2cd2766g2ht-izs",
    "a": "hikvision-ds-2cd2766g2h-iptrzs2u-s-l-rb",
    "b": "hikvision-ds-2cd2766g2ht-izs",
    "kind": "within-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-dahua-tpc-bf3221p-t",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "dahua-tpc-bf3221p-t",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-axis-axis-q1942-e-60mm",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "axis-axis-q1942-e-60mm",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-hanwha-tno-c3080t",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "hanwha-tno-c3080t",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-uniview-ipc252era-x22dug",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "uniview-ipc252era-x22dug",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-pelco-exf1230-4n",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "pelco-exf1230-4n",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-vivotek-tb9301-e",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-i-pro-wv-s1536ltn",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2td2667-25-qy-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "hikvision-ds-2td2667-25-qy",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-axis-axis-q1942-e-60mm",
    "a": "dahua-tpc-bf3221p-t",
    "b": "axis-axis-q1942-e-60mm",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "a": "dahua-tpc-bf3221p-t",
    "b": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-hanwha-tno-c3080t",
    "a": "dahua-tpc-bf3221p-t",
    "b": "hanwha-tno-c3080t",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-uniview-ipc252era-x22dug",
    "a": "dahua-tpc-bf3221p-t",
    "b": "uniview-ipc252era-x22dug",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-pelco-exf1230-4n",
    "a": "dahua-tpc-bf3221p-t",
    "b": "pelco-exf1230-4n",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-vivotek-tb9301-e",
    "a": "dahua-tpc-bf3221p-t",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-i-pro-wv-s1536ltn",
    "a": "dahua-tpc-bf3221p-t",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf3221p-t-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "dahua-tpc-bf3221p-t",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "a": "axis-axis-q1942-e-60mm",
    "b": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-hanwha-tno-c3080t",
    "a": "axis-axis-q1942-e-60mm",
    "b": "hanwha-tno-c3080t",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-uniview-ipc252era-x22dug",
    "a": "axis-axis-q1942-e-60mm",
    "b": "uniview-ipc252era-x22dug",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-pelco-exf1230-4n",
    "a": "axis-axis-q1942-e-60mm",
    "b": "pelco-exf1230-4n",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-vivotek-tb9301-e",
    "a": "axis-axis-q1942-e-60mm",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-i-pro-wv-s1536ltn",
    "a": "axis-axis-q1942-e-60mm",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1942-e-60mm-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "axis-axis-q1942-e-60mm",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-thermal-8100i-nbt-8701-f42vf-vs-hanwha-tno-c3080t",
    "a": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "b": "hanwha-tno-c3080t",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-thermal-8100i-nbt-8701-f42vf-vs-uniview-ipc252era-x22dug",
    "a": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "b": "uniview-ipc252era-x22dug",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-thermal-8100i-nbt-8701-f42vf-vs-pelco-exf1230-4n",
    "a": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "b": "pelco-exf1230-4n",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-thermal-8100i-nbt-8701-f42vf-vs-vivotek-tb9301-e",
    "a": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-thermal-8100i-nbt-8701-f42vf-vs-i-pro-wv-s1536ltn",
    "a": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-thermal-8100i-nbt-8701-f42vf-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "bosch-dinion-thermal-8100i-nbt-8701-f42vf",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-tno-c3080t-vs-uniview-ipc252era-x22dug",
    "a": "hanwha-tno-c3080t",
    "b": "uniview-ipc252era-x22dug",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-tno-c3080t-vs-pelco-exf1230-4n",
    "a": "hanwha-tno-c3080t",
    "b": "pelco-exf1230-4n",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-tno-c3080t-vs-vivotek-tb9301-e",
    "a": "hanwha-tno-c3080t",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-tno-c3080t-vs-i-pro-wv-s1536ltn",
    "a": "hanwha-tno-c3080t",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-tno-c3080t-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "hanwha-tno-c3080t",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-ipc252era-x22dug-vs-pelco-exf1230-4n",
    "a": "uniview-ipc252era-x22dug",
    "b": "pelco-exf1230-4n",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-ipc252era-x22dug-vs-vivotek-tb9301-e",
    "a": "uniview-ipc252era-x22dug",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-ipc252era-x22dug-vs-i-pro-wv-s1536ltn",
    "a": "uniview-ipc252era-x22dug",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-ipc252era-x22dug-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "uniview-ipc252era-x22dug",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "pelco-exf1230-4n-vs-vivotek-tb9301-e",
    "a": "pelco-exf1230-4n",
    "b": "vivotek-tb9301-e",
    "kind": "cross-brand"
  },
  {
    "slug": "pelco-exf1230-4n-vs-i-pro-wv-s1536ltn",
    "a": "pelco-exf1230-4n",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "pelco-exf1230-4n-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "pelco-exf1230-4n",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "vivotek-tb9301-e-vs-i-pro-wv-s1536ltn",
    "a": "vivotek-tb9301-e",
    "b": "i-pro-wv-s1536ltn",
    "kind": "cross-brand"
  },
  {
    "slug": "vivotek-tb9301-e-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "vivotek-tb9301-e",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "i-pro-wv-s1536ltn-vs-avigilon-2-0c-h5a-hb2-ir",
    "a": "i-pro-wv-s1536ltn",
    "b": "avigilon-2-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-axis-axis-q1786-le-29",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "axis-axis-q1786-le-29",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-bosch-dinion-7100i-ir-nbe-7703-alx",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-hanwha-pno-a7082r",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "hanwha-pno-a7082r",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-uniview-tic2624s-f35-4f12ac-i3",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "uniview-tic2624s-f35-4f12ac-i3",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-pelco-srxe4-4v22-ebt-ir1",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "pelco-srxe4-4v22-ebt-ir1",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-vivotek-ib9371-eht-lr",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-i-pro-wv-x67300-z4l3",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ids-2cd7a45g2-izhs-y-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "hikvision-ids-2cd7a45g2-izhs-y",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-axis-axis-q1786-le-29",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "axis-axis-q1786-le-29",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-bosch-dinion-7100i-ir-nbe-7703-alx",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-hanwha-pno-a7082r",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "hanwha-pno-a7082r",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-uniview-tic2624s-f35-4f12ac-i3",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "uniview-tic2624s-f35-4f12ac-i3",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-pelco-srxe4-4v22-ebt-ir1",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "pelco-srxe4-4v22-ebt-ir1",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-vivotek-ib9371-eht-lr",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-i-pro-wv-x67300-z4l3",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-bosch-dinion-7100i-ir-nbe-7703-alx",
    "a": "axis-axis-q1786-le-29",
    "b": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-hanwha-pno-a7082r",
    "a": "axis-axis-q1786-le-29",
    "b": "hanwha-pno-a7082r",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-uniview-tic2624s-f35-4f12ac-i3",
    "a": "axis-axis-q1786-le-29",
    "b": "uniview-tic2624s-f35-4f12ac-i3",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-pelco-srxe4-4v22-ebt-ir1",
    "a": "axis-axis-q1786-le-29",
    "b": "pelco-srxe4-4v22-ebt-ir1",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-vivotek-ib9371-eht-lr",
    "a": "axis-axis-q1786-le-29",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-i-pro-wv-x67300-z4l3",
    "a": "axis-axis-q1786-le-29",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "axis-axis-q1786-le-29-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "axis-axis-q1786-le-29",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-7100i-ir-nbe-7703-alx-vs-hanwha-pno-a7082r",
    "a": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "b": "hanwha-pno-a7082r",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-7100i-ir-nbe-7703-alx-vs-uniview-tic2624s-f35-4f12ac-i3",
    "a": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "b": "uniview-tic2624s-f35-4f12ac-i3",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-7100i-ir-nbe-7703-alx-vs-pelco-srxe4-4v22-ebt-ir1",
    "a": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "b": "pelco-srxe4-4v22-ebt-ir1",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-7100i-ir-nbe-7703-alx-vs-vivotek-ib9371-eht-lr",
    "a": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-7100i-ir-nbe-7703-alx-vs-i-pro-wv-x67300-z4l3",
    "a": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "bosch-dinion-7100i-ir-nbe-7703-alx-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "bosch-dinion-7100i-ir-nbe-7703-alx",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-pno-a7082r-vs-uniview-tic2624s-f35-4f12ac-i3",
    "a": "hanwha-pno-a7082r",
    "b": "uniview-tic2624s-f35-4f12ac-i3",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-pno-a7082r-vs-pelco-srxe4-4v22-ebt-ir1",
    "a": "hanwha-pno-a7082r",
    "b": "pelco-srxe4-4v22-ebt-ir1",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-pno-a7082r-vs-vivotek-ib9371-eht-lr",
    "a": "hanwha-pno-a7082r",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-pno-a7082r-vs-i-pro-wv-x67300-z4l3",
    "a": "hanwha-pno-a7082r",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "hanwha-pno-a7082r-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "hanwha-pno-a7082r",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-tic2624s-f35-4f12ac-i3-vs-pelco-srxe4-4v22-ebt-ir1",
    "a": "uniview-tic2624s-f35-4f12ac-i3",
    "b": "pelco-srxe4-4v22-ebt-ir1",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-tic2624s-f35-4f12ac-i3-vs-vivotek-ib9371-eht-lr",
    "a": "uniview-tic2624s-f35-4f12ac-i3",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-tic2624s-f35-4f12ac-i3-vs-i-pro-wv-x67300-z4l3",
    "a": "uniview-tic2624s-f35-4f12ac-i3",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "uniview-tic2624s-f35-4f12ac-i3-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "uniview-tic2624s-f35-4f12ac-i3",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "pelco-srxe4-4v22-ebt-ir1-vs-vivotek-ib9371-eht-lr",
    "a": "pelco-srxe4-4v22-ebt-ir1",
    "b": "vivotek-ib9371-eht-lr",
    "kind": "cross-brand"
  },
  {
    "slug": "pelco-srxe4-4v22-ebt-ir1-vs-i-pro-wv-x67300-z4l3",
    "a": "pelco-srxe4-4v22-ebt-ir1",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "pelco-srxe4-4v22-ebt-ir1-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "pelco-srxe4-4v22-ebt-ir1",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "vivotek-ib9371-eht-lr-vs-i-pro-wv-x67300-z4l3",
    "a": "vivotek-ib9371-eht-lr",
    "b": "i-pro-wv-x67300-z4l3",
    "kind": "cross-brand"
  },
  {
    "slug": "vivotek-ib9371-eht-lr-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "vivotek-ib9371-eht-lr",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "i-pro-wv-x67300-z4l3-vs-avigilon-4-0c-h5a-hb2-ir",
    "a": "i-pro-wv-x67300-z4l3",
    "b": "avigilon-4-0c-h5a-hb2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-dahua-ipc-hfw5541t-ase",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "dahua-ipc-hfw5541t-ase",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-axis-p1447-le-29mm",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "axis-p1447-le-29mm",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-bosch-dinion-7100i-ir-nbe-7703-alt",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "bosch-dinion-7100i-ir-nbe-7703-alt",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-hanwha-xno-8040r",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "hanwha-xno-8040r",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-uniview-ipc265eb-dx12k-i0",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "uniview-ipc265eb-dx12k-i0",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-pelco-srxp4-5v32-ebt-ir",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "pelco-srxp4-5v32-ebt-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-vivotek-ib9387-ehtl",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "vivotek-ib9387-ehtl",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-i-pro-wv-s1556l-lk",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "i-pro-wv-s1556l-lk",
    "kind": "cross-brand"
  },
  {
    "slug": "hikvision-ds-2cd1t67g3-liu-sl-4mm-vs-avigilon-5-0c-h6a-bo2-ir",
    "a": "hikvision-ds-2cd1t67g3-liu-sl-4mm",
    "b": "avigilon-5-0c-h6a-bo2-ir",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-ipc-hfw5541t-ase-vs-axis-p1447-le-29mm",
    "a": "dahua-ipc-hfw5541t-ase",
    "b": "axis-p1447-le-29mm",
    "kind": "cross-brand"
  },
  {
    "slug": "dahua-tpc-bf5421-t-vs-dahua-tpc-bf5421p-t",
    "a": "dahua-tpc-bf5421-t",
    "b": "dahua-tpc-bf5421p-t",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw7459z1-z10-pv-x-atc-vs-dahua-tpc-bf5441-b19f12-dc-s5-v1",
    "a": "dahua-ipc-hfw7459z1-z10-pv-x-atc",
    "b": "dahua-tpc-bf5441-b19f12-dc-s5-v1",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-bf5441-b19f12-dc-s5-v1-vs-dahua-tpc-bf5441-b25f12-dc-s5-v1",
    "a": "dahua-tpc-bf5441-b19f12-dc-s5-v1",
    "b": "dahua-tpc-bf5441-b25f12-dc-s5-v1",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-bf5441-b25f12-dc-s5-v1-vs-dahua-tpc-bf5641-b19f12",
    "a": "dahua-tpc-bf5441-b25f12-dc-s5-v1",
    "b": "dahua-tpc-bf5641-b19f12",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-tpc-bf5641-b19f12-vs-dahua-tpc-bf5641-b25f12",
    "a": "dahua-tpc-bf5641-b19f12",
    "b": "dahua-tpc-bf5641-b25f12",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw5541t-ase-vs-dahua-ipc-hfw5541e-ze-s3",
    "a": "dahua-ipc-hfw5541t-ase",
    "b": "dahua-ipc-hfw5541e-ze-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw5541e-ze-s3-vs-dahua-ipc-hfw5541e-ze-s2",
    "a": "dahua-ipc-hfw5541e-ze-s3",
    "b": "dahua-ipc-hfw5541e-ze-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw5541e-ze-s2-vs-dahua-ipc-hfw2541s-s-0600b-s2",
    "a": "dahua-ipc-hfw5541e-ze-s2",
    "b": "dahua-ipc-hfw2541s-s-0600b-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hfw2541s-s-0600b-s2-vs-dahua-ipc-hfw2541t-as-0600b-s2",
    "a": "dahua-ipc-hfw2541s-s-0600b-s2",
    "b": "dahua-ipc-hfw2541t-as-0600b-s2",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw5541e-z5e-s3-vs-dahua-ipc-hdbw5541e-ze-s3",
    "a": "dahua-ipc-hdbw5541e-z5e-s3",
    "b": "dahua-ipc-hdbw5541e-ze-s3",
    "kind": "within-brand"
  },
  {
    "slug": "dahua-ipc-hdbw5541e-ze-s3-vs-dahua-ipc-hdw2541t-s-0600b-s2",
    "a": "dahua-ipc-hdbw5541e-ze-s3",
    "b": "dahua-ipc-hdw2541t-s-0600b-s2",
    "kind": "within-brand"
  }
];

export const SKU_COMPARISON_SLUGS: string[] = SKU_COMPARISON_PAIRS.map(p => p.slug);
